const idNameItems = (items) =>
  (items || []).map((item) => ({
    label: item.name,
    value: String(item.id),
  }))

const studentItems = (items) =>
  (items || []).map((item) => ({
    label: `${item.last_name} ${item.first_name} (${item.email})`,
    value: String(item.id),
  }))

const ITEM_BUILDERS = {
  course: idNameItems,
  case: idNameItems,
  student: studentItems,
}

export function reportDashboardSelectItems(type, items) {
  const builder = ITEM_BUILDERS[type]
  return builder ? builder(items) : []
}
